export default __webpack_public_path__ + "static/media/sentiment_satisfied.e9606bef.svg";